import { NavLink } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/authStore';
import { dashboardKeys } from '@/features/dashboard/hooks/useDashboard';
import { dashboardService } from '@/features/dashboard/services/dashboardService';

const baseNavigation = [
  { name: 'Dashboard', href: '/dashboard' },
  { name: 'Frames to Order', href: '/frames-to-order' },
  { name: 'Weekly Ordering', href: '/weekly-ordering' },
  { name: 'Receiving', href: '/receiving' },
  { name: 'Reports', href: '/reports' },
];

const adminNavigation = { name: 'Admin', href: '/admin' };

export function Sidebar() {
  const queryClient = useQueryClient();
  const { user } = useAuthStore();

  // Only show Admin link to admin users
  const navigation = user?.is_admin
    ? [...baseNavigation, adminNavigation]
    : baseNavigation;

  // Prefetch dashboard data on hover
  const handleDashboardHover = () => {
    const locationIds = user?.locations?.map((l) => l.id) || [];
    if (locationIds.length > 0) {
      // Prefetch in parallel - don't wait for completion
      Promise.all([
        queryClient.prefetchQuery({
          queryKey: dashboardKeys.alerts(locationIds),
          queryFn: () => dashboardService.getDashboardAlerts(locationIds),
        }),
        queryClient.prefetchQuery({
          queryKey: dashboardKeys.summary(locationIds),
          queryFn: () => dashboardService.getMultiLocationSummary(locationIds),
        }),
      ]).catch((err) => {
        // Silently fail prefetch - dashboard will fetch on load
        console.error('Dashboard prefetch on hover failed:', err);
      });
    }
  };

  return (
    <aside className="w-64 bg-white border-r border-gray-200 h-[calc(100vh-4rem)] flex-shrink-0">
      <nav className="p-4 space-y-1 h-full overflow-y-auto">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            onMouseEnter={item.name === 'Dashboard' ? handleDashboardHover : undefined}
            className={({ isActive }) =>
              `block px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-gray-700 hover:bg-gray-50'
              }`
            }
          >
            {item.name}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
